import React, { useState, useEffect } from 'react';
import { Capacitor } from '@capacitor/core';
import { Clipboard } from '@capacitor/clipboard';

const SupportModal = () => {
  const [open, setOpen] = useState(false);
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    const handleOpen = () => setOpen(true);
    window.addEventListener('openSupportModal', handleOpen);
    return () => window.removeEventListener('openSupportModal', handleOpen);
  }, []);

  if (!open) return null;

  const handleCopy = async () => {
    const text = 'support@linksy.community';
    try {
      if (Capacitor.isNativePlatform?.()) {
        await Clipboard.write({ string: text });
      } else {
        await navigator.clipboard.writeText(text);
      }
      setCopied(true);
      setTimeout(() => setCopied(false), 1500);
    } catch (e) { console.error('Copy error:', e); }
  };

  return (
    <div
      onClick={() => setOpen(false)}
      style={{
        position: 'fixed',
        inset: 0,
        background: 'rgba(0,0,0,0.5)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 10001,
        animation: 'fadeIn 0.2s ease-out'
      }}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        style={{
          background: 'white',
          borderRadius: '16px',
          padding: '24px',
          maxWidth: '420px',
          width: '90%',
          boxShadow: '0 20px 60px rgba(0,0,0,0.3)',
          animation: 'slideUp 0.3s ease-out'
        }}
      >
        {/* Icon */}
        <div style={{
          width: '56px', height: '56px',
          background: 'linear-gradient(135deg, #34a853 0%, #288140 100%)',
          borderRadius: '50%',
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          margin: '0 auto 16px'
        }}>
          <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <circle cx="12" cy="12" r="10" />
            <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3" />
            <line x1="12" y1="17" x2="12.01" y2="17" />
          </svg>
        </div>

        {/* Title */}
        <h3 style={{ margin: '0 0 8px', fontSize: '20px', fontWeight: 600, color: '#202124', textAlign: 'center' }}>
          Help & Policies
        </h3>

        {/* Message */}
        <p style={{ margin: '0 0 20px', fontSize: '14px', color: '#5f6368', textAlign: 'center', lineHeight: 1.6 }}>
          We're here to help! If you have any questions, feedback, or need assistance, please reach out to our support team.
        </p>

{/* Email box */}
<div style={{
  background: '#f8f9fa', borderRadius: '12px', padding: '16px',
  marginBottom: '20px'
}}>
  {/* Desktop layout */}
  <div className="support-email-desktop" style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
    <div style={{
      width: '40px', height: '40px', background: 'white', borderRadius: '10px',
      display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0
    }}>
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#34a853" strokeWidth="2">
        <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
        <polyline points="22,6 12,13 2,6" />
      </svg>
    </div>
    <div style={{ flex: 1, minWidth: 0 }}>
      <p style={{ margin: '0 0 2px', fontSize: '11px', color: '#5f6368', textTransform: 'uppercase', letterSpacing: '0.5px' }}>
        Email us at
      </p>
      <p style={{ margin: 0, fontSize: '15px', fontWeight: 500, color: '#202124', wordBreak: 'break-all' }}>
        support@linksy.community
      </p>
    </div>
    <button
      onClick={handleCopy}
      onMouseOver={(e) => e.currentTarget.style.background = '#298541'}
      onMouseOut={(e) => e.currentTarget.style.background = '#34a853'}
      style={{
        padding: '8px 12px', background: '#34a853', color: 'white',
        border: 'none', borderRadius: '6px', fontSize: '12px',
        fontWeight: 600, cursor: 'pointer', transition: 'all 0.2s', whiteSpace: 'nowrap'
      }}
    >
      {copied ? 'Copied!' : 'Copy'}
    </button>
  </div>

  {/* Mobile layout */}
  <div className="support-email-mobile" style={{ display: 'none', flexDirection: 'column', alignItems: 'center', gap: '8px', textAlign: 'center' }}>
    <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
      <div style={{
        width: '32px', height: '32px', background: 'white', borderRadius: '8px',
        display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0
      }}>
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#34a853" strokeWidth="2">
          <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
          <polyline points="22,6 12,13 2,6" />
        </svg>
      </div>
      <p style={{ margin: 0, fontSize: '11px', color: '#5f6368', textTransform: 'uppercase', letterSpacing: '0.5px' }}>
        Email us at
      </p>
    </div>
    <p style={{ margin: 0, fontSize: '15px', fontWeight: 500, color: '#202124' }}>
      support@linksy.community
    </p>
    <button
      onClick={handleCopy}
      onMouseOver={(e) => e.currentTarget.style.background = '#298541'}
      onMouseOut={(e) => e.currentTarget.style.background = '#34a853'}
      style={{
        padding: '8px 16px', background: '#34a853', color: 'white',
        border: 'none', borderRadius: '6px', fontSize: '12px',
        fontWeight: 600, cursor: 'pointer', transition: 'all 0.2s'
      }}
    >
      {copied ? 'Copied!' : 'Copy'}
    </button>
  </div>
</div>

        {/* Terms & Privacy links */}
        <div style={{ display: 'flex', justifyContent: 'center', gap: '16px', marginBottom: '12px' }}>
          <a
            href="/terms"
            target="_blank"
            rel="noopener noreferrer"
            style={{ fontSize: '13px', color: '#5f6368', textDecoration: 'none', borderBottom: '1px solid #dadce0', paddingBottom: '1px' }}
          >
            Terms & Conditions
          </a>
          <span style={{ color: '#dadce0' }}>·</span>
          <a
            href="/privacy"
            target="_blank"
            rel="noopener noreferrer"
            style={{ fontSize: '13px', color: '#5f6368', textDecoration: 'none', borderBottom: '1px solid #dadce0', paddingBottom: '1px' }}
          >
            Privacy Policy
          </a>
        </div>

        {/* Close button */}
        <button
          onClick={() => setOpen(false)}
          onMouseOver={(e) => e.currentTarget.style.background = '#f1f3f4'}
          onMouseOut={(e) => e.currentTarget.style.background = '#f8f9fa'}
          style={{
            width: '100%', padding: '12px', background: '#f8f9fa',
            color: '#5f6368', border: '2px solid #dadce0', borderRadius: '8px',
            fontSize: '15px', fontWeight: 600, cursor: 'pointer', transition: 'all 0.2s'
          }}
        >
          Close
        </button>
      </div>

      <style>{`
        @keyframes fadeIn { from { opacity: 0; } to { opacity: 1; } }
        @keyframes slideUp { from { transform: translateY(20px); opacity: 0; } to { transform: translateY(0); opacity: 1; } }
        @media (max-width: 800px) {
  .support-email-desktop { display: none !important; }
  .support-email-mobile { display: flex !important; }
}
      `}</style>
    </div>
  );
};

export default SupportModal;